export default function authHeader() {
    const user = JSON.parse(localStorage.getItem('user'));

    if (user) {
        return { 'Content-Type': 'application/json', Authorization: 'Bearer ' + user.JWT };
    } else {
        return {};
    }
}